// extracted by mini-css-extract-plugin
export default {"container":"QXARZy","content":"JAGmqf","sidePanel":"aceER6","videoRecorder":"KjYq97"};